import {CategoryType, type DocumentCategoryType, type LogLevelType, LogLevel} from '~/libs/document-intelligence-types'

export function snakeCaseToWords(str: string): string {
  // Convert SNAKE_CASE to space-separated words in lowercase
  return str.replace(/_/g, ' ').toLowerCase()
}

export function getCategoryLabelFromType(categoryTypeValue: DocumentCategoryType): string {
  // Find the key in CategoryType that matches the value
  const categoryKey = Object.keys(CategoryType).find(
    key => CategoryType[key as keyof typeof CategoryType] === categoryTypeValue
  )

  if (categoryKey) {
    return snakeCaseToWords(categoryKey)
  }

  return 'document'
}

export function getIndefiniteArticle(word: string): string {
  // Check if the word starts with a vowel sound
  const vowels = ['a', 'e', 'i', 'o', 'u']
  return vowels.includes(word.charAt(0).toLowerCase()) ? 'an' : 'a'
}

export function formatDocumentMessage(doc: { label?: string; filename?: string; categoryType?: DocumentCategoryType }): string {
  const label = doc.label || doc.filename || 'Unknown document'

  if (doc.categoryType) {
    const categoryLabel = getCategoryLabelFromType(doc.categoryType)
    const article = getIndefiniteArticle(categoryLabel)
    return `${label} - appears not to be ${article} ${categoryLabel}`
  }

  return label
}

export function docIntelligenceLog(message: string, level: LogLevelType, data: Record<string, any> = {}): void {
  const prefix = '[Document Intelligence]'

  switch (level){
    case LogLevel.INFO:
      // @ts-expect-error - log is globally declared
      log.info(`${prefix} ${message}`, data)
      return
    case LogLevel.ERROR:
      // @ts-expect-error - log is globally declared
      log.error(`${prefix} ${message}`, data)
      return
    case LogLevel.WARNING:
      // @ts-expect-error - log is globally declared
      log.warning(`${prefix} ${message}`, data)
      return
  }
}
